import styled, { css } from 'styled-components';

export const Content = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
`;

export const Popup = styled.div`
  position: absolute;
  z-index: 999;
  top: 20px;
  padding: 0 20px;
  height: 40px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.4);
  background-image: linear-gradient(to bottom, #ffffff, #ffffff), linear-gradient(to bottom, rgba(255, 255, 255, 0.5), rgba(0, 0, 0, 0.5));
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  div {
    top: -10px;
    z-index: 998;
    position: absolute;
    border-bottom: 10px solid white;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
  }
  ${(props) =>
    props.theme.theme === 'dark' &&
    css`
      background-image: linear-gradient(to bottom, #000, #000), linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(255, 255, 255, 0.5));
      color: #fff;
      div {
        border-bottom-color: black;
      }
    `}
  ${(props) =>
    props.theme.ui === 'v2' &&
    css`
      background-image: none;
      background: var(--cp-surface);
      color: var(--cp-text);
      box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.4), 0 0 0 1px var(--cp-border);
      div {
        border-bottom-color: var(--cp-surface);
      }
    `}
`;
